"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _moment = _interopRequireDefault(require("moment"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _teaserItem = _interopRequireDefault(require("../teaser-item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(4, 0)
  },
  date: {
    flex: "0 0 100%",
    maxWidth: "100%"
  },
  headline: {
    marginTop: theme.spacing(2)
  }
}));
const WeeklyProgram = _ref => {
  var _activityData$items;
  let {
    providers
  } = _ref;
  const [activityData, setActivityData] = (0, _react.useState)({});
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  let lastDate = null;
  (0, _react.useEffect)(() => {
    async function fetchData() {
      const {
        REACT_APP_PATH,
        REACT_APP_PROVIDER_ID
      } = process.env;
      const fetchURL = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListActivity.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language, "&pageSize=100");

      // read and send token

      const headers = {};
      if (localStorage.getItem("logintoken")) {
        headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
      }
      const response = await fetch(fetchURL, {
        headers
      });
      setActivityData(await response.json());
    }
    fetchData();
  }, [i18n.language, providers]);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.root,
    container: true,
    spacing: 2
  }, activityData === null || activityData === void 0 || (_activityData$items = activityData.items) === null || _activityData$items === void 0 ? void 0 : _activityData$items.map((item, counter) => {
    var _first, _item$date, _item$date2, _item$date3;
    let headline = null;
    const image = (_first = (0, _lodash.first)(item === null || item === void 0 ? void 0 : item.media)) === null || _first === void 0 || (_first = _first.subFormats) === null || _first === void 0 ? void 0 : _first.find(m => {
      return m.formatIdentifier === "activities-small";
    });
    if (item.date.from !== lastDate) {
      headline = /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        className: css.headline
      }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
        uppercase: false,
        title: (0, _moment.default)(item.date.from).format("dddd") + ", " + (0, _moment.default)(item.date.from).format("D. MMMM YYYY")
      }));
      lastDate = item.date.from;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: counter
    }, headline, /*#__PURE__*/_react.default.createElement(_teaserItem.default, {
      title: item === null || item === void 0 ? void 0 : item.title,
      imageObj: image,
      timeFrom: item === null || item === void 0 || (_item$date = item.date) === null || _item$date === void 0 ? void 0 : _item$date.timeFrom,
      timeTo: item === null || item === void 0 || (_item$date2 = item.date) === null || _item$date2 === void 0 ? void 0 : _item$date2.timeTo,
      pageName: "".concat(item === null || item === void 0 ? void 0 : item.pageName, "#").concat(item === null || item === void 0 || (_item$date3 = item.date) === null || _item$date3 === void 0 ? void 0 : _item$date3.from)
    }));
  }));
};
var _default = exports.default = WeeklyProgram;